/*
  Tour Planning
*/
import React, { useEffect, useRef, useState } from "react";
import ArrowLeft from ".//..//..//..//..//..//assets//images//icons//arrow-left.svg";
import ButtonFluid from "../../../../../components/common/buttons/ButtonFluid";
import BackButton from "../../../../../components/calculator/ConditionLabel/BackButton";
import StepBar from "../../../../../components/calculator/Wizard/StepBar";
import {
  DirectionsRenderer,
  GoogleMap,
  Marker,
  useJsApiLoader,
  StreetViewPanorama,
  InfoWindow,
} from "@react-google-maps/api";
import CameraIcon from ".//..//..//..//.//..//..//assets//images//icons//camera.svg";
import BinIcon from ".//..//..//..//.//..//..//assets//images//icons//bin-light.svg";

import FullScreenIcon from ".//..//..//..//.//..//..//assets//images//icons//full-screen.png";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../constants/Routes";

import TripPlanner from "./TripPlanner";
import { useDispatch } from "react-redux";
import Spinner from "../../../../../components/common/Splnner/Spinner";
import HttpHelper from "../../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../../constants/API_ROUTES";
import useAuth from "../../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { useScreenshot } from "use-react-screenshot";
import html2canvas from "html2canvas";
import SpinnerCapture from "../../../../../components/common/Splnner/SpinnerCapture";

const containerStyle = {
  width: "100%",
  height: "600px",
};

const center = {
  lat: 47.7781768,
  lng: 9.6079086,
};

const Turatervezes = () => {
  //read url params
  const [stateUpdating, setStateUpdating] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");

  const dispatch = useDispatch();
  const [step, setStep] = useState(2);
  const { getAuth, clearAuth } = useAuth();
  const mapKey = "AIzaSyAjWAttLzOFNw-GjKMxxUP8fFq8bSkprNY";
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: mapKey,
  });

  const [map, setMap] = React.useState(null);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const [mapFullScreen, setMapFullScreen] = useState(false);
  // ------------------------------------------------------------------------------------------
  const [routes, setRoutes] = useState(null);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [distances, setDistances] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);
  const [interDistances, setInterDistances] = useState([]);
  const [startLocations, setStartLocations] = useState([]);
  const [proposalKey, setProposalKey] = useState("");
  const addDestination = () => {
    setDestinations([...destinations, ""]);
  };

  const removeDestination = (index, placeId) => {
    setDestinations((prevItems) => {
      const newArray = [...prevItems];
      newArray.splice(index, 1);
      return newArray;
    });

    updateMap(destinations);
  };

  const parseDistance = (distanceString) => {
    const parts = distanceString.split(" ");
    const value = parseFloat(parts[0].replace(/,/g, ""));
    const unit = parts[1];
    if (unit === "m") {
      return value; // Convert meters to kilometers
    } else {
      return value * 1000; // Return kilometers as is
    }
  };

  const searchChange = (e, index) => {
    setDestinations((prevItems) => {
      const newArray = [...prevItems];
      newArray[index] = {
        ...newArray[index],
        address: e,
      };
      return newArray;
    });
  };

  function makeid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const updateMap = (
    streetNumber,
    route,
    country,
    locality,
    postalCode,
    placeId,
    name,
    address,
    lat,
    lng,
    index,
    start_index
  ) => {
    setDestinations((prevItems) => {
      console.info(index);
      const newArray = [...prevItems];
      const uniqueId = `${Date.now()}${makeid(5)}`;
      newArray[index] = {
        ...newArray[index],
        streetNumber,
        route,
        country,
        locality,
        postalCode,
        placeId,
        name,
        address,
        lat,
        lng,
        start_index,
      };
      console.log(newArray);
      return newArray;
    });

    // setDestinations((prevData) => [...prevData, des]);
  };

  useEffect(() => {
    if (destinations.length > 0) {
      drawRoutes(destinations);
    }
  }, [destinations]);

  //
  const drawRoutes = async (address) => {
    console.log(address);
    setStateUpdating(true);
    const startLocation = destinations[0];
    let totalDis = 0;
    // const places = [{ lat: parseFloat(initialLat) ?? 47.7781768, lng: parseFloat(initialLng) ?? 9.6079086 }];
    const places = [
      {
        lat: parseFloat(startLocation.lat) ?? 47.7781768,
        lng: parseFloat(startLocation.lng) ?? 9.6079086,
        placeId: startLocation?.placeId,
        endDesIndex: startLocation?.uniqueId,
      },
    ];

    const wayPoints = [];
    if (address.length > 1) {
      for (let i = 1; i < address.length; i++) {
        if (address[i] !== " ") {
          places.push({
            lat: address[i].lat,
            lng: address[i].lng,
            placeId: address[i]?.placeId,
            endDesIndex: address[i]?.uniqueId,
          });
          if (i !== 0 || i !== address.length) {
            wayPoints.push({
              location: {
                lat: address[i].lat,
                lng: address[i].lng,
                placeId: address[i]?.placeId,
                endDesIndex: address[i]?.uniqueId,
              },
            });
          }
        }
      }
    }

    const disArray = [];

    if (address.length > 0) {
      setDistances([]);
      const startingDestination = places[0];
      const endDestination = address.length >= 2 ? places.at(-1) : places[0];
      //
      if (startingDestination === "" || endDestination === "") {
        return;
      }

      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService();
      // console.log(destinationRef)
      const results = await directionsService.route({
        origin: startingDestination,
        destination: endDestination,
        waypoints: wayPoints,
        // eslint-disable-next-line no-undef
        travelMode: google.maps.TravelMode.DRIVING,
      });

      places.forEach(async (place, i) => {
        const startingDestination = places[i];
        const endDestination = places[i + 1];

        const dis = await directionsService.route({
          origin: startingDestination,
          destination: endDestination,
          // eslint-disable-next-line no-undef
          travelMode: google.maps.TravelMode.DRIVING,
        });

        totalDis += parseDistance(dis.routes[0].legs[0].distance.text);
        setTotalDistance(totalDis);

        setDistances((prevArray) => [
          ...prevArray,
          {
            startingDestination: startingDestination?.placeId,
            endDestination: endDestination?.placeId,
            endDesIndex: endDestination?.endDesIndex,
            distanceBetween: dis.routes[0].legs[0].distance.text,
          },
        ]);
      });

      //  setDistances(disArray);
      setStateUpdating(false);
      setRoutes(results);
    }
  };

  const fetchTourPlan = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_TOURPLAN_LIST}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          const proposalTourPlan = data?.data?.proposalTourPlan;
          const startLocations = data?.data?.startLocations;
          const tourImages = data?.data?.tourImages;
          const proposalData = data?.data?.proposalData;
          setProposalKey(proposalData[0]?.proposal_number);
          const images = [];
          tourImages.map((image) => {
            images.push({
              place_id: image?.place_id,
              image: image?.image,
            });
          });

          setStreetViewCapArr(images);

          setStartLocations(startLocations);
          const arr = [];
          proposalTourPlan.forEach((item, index) => {
            const streetNumber = item?.streetNumber;
            const route = item?.route;
            const country = item?.country;
            const locality = item?.locality;
            const postalCode = item?.postalCode;
            const placeId = item?.place_id;
            const name = item?.helyszin_neve;
            const address = item?.cim;
            const lat = item?.latitude;
            const lng = item?.longitute;
            const start_index = item?.start_index;
            const uniqueId = `${Date.now()}${makeid(5)}`;
            arr.push({
              streetNumber,
              route,
              country,
              locality,
              postalCode,
              placeId,
              name,
              address,
              lat,
              lng,
              uniqueId,
              start_index,
            });
          });
          setDestinations(arr);
          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    fetchTourPlan();
  }, []);

  const getInterDistance = (placeId) => {
    const interDistance = distances?.filter((item) => item?.endDestination === placeId)[0]?.distanceBetween;
    //  setInterDistance(interDistance, placeId, index);
    return interDistance;
  };

  const saveTourPlan = () => {
    console.log(destinations, distances);
    const convertedDestinations = destinations.map((item, index) => {
      console.log(getInterDistance(item?.placeId));
      return {
        place_id: item.placeId,
        cim: item.address,
        helyszin_neve: item.name,
        latitude: item.lat,
        longitute: item.lng,
        streetNumber: item.streetNumber,
        route: item.route,
        country: item.country,
        postalCode: item.postalCode,
        locality: item.locality,
        inter_distance: index != 0 ? getInterDistance(item?.placeId) : 0,
        emelet: "",
        tavolsag: "",
        megallo: "",
        lift: false,
        szuk_lepcsohaz: false,
        kozteruleti_ugyintezes: false,
        note: "",
        sort_index: index,
        start_index: item?.start_index,
      };
    });

    console.log(convertedDestinations);
    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        places: convertedDestinations,
        tourImages: streetViewCapArr,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          // reset();
          setSpinnerVisible(false);
          // refreshCustomerList();
          toast.success("A túratervezés sikeresen mentve!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_MANAGE_ADDRESS_DATA}?p-id=${proposalId}`);
        } else if (res.status === 422) {
          const messages = res.message;
          console.log(messages);
          setSpinnerVisible(false);
          toast.error("Hiba: a javaslat nem lett létrehozva.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          setSpinnerVisible(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpinnerVisible(false);
        toast.error("Hiba: a javaslat nem lett létrehozva.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const fullScreenToggle = () => {
    setMapFullScreen(!mapFullScreen);
  };

  // screen shot ------
  const mapRef = useRef(null);
  const [image, takeScreenshot] = useScreenshot();
  const [screenshot, setScreenshot] = useState(null);

  const pushStartLocation = (newStartLocatiion) => {
    setStartLocations((prevLocations) => [...prevLocations, newStartLocatiion]);
  };

  const [streetView, setStreetView] = useState("");
  const [streetViewVisibility, setStreetViewVisibility] = useState(false);
  const [streetViewCapturing, setStreetViewCapturing] = useState(false);
  const [loading, setLoading] = useState(1);
  const [panorama, setPanorama] = useState("");
  const [panoPosition, setPanoPosition] = useState();
  const [initpanoPosition, setInitPanoPosition] = useState({
    lat: 47.7781768,
    lng: 9.6079086,
  });

  const [panoPov, setPanoPov] = useState("");
  const [streetViewCapArr, setStreetViewCapArr] = useState([]);
  const [streetViewCapId, setStreetViewCapId] = useState("");

  const getStreetView = (index, place) => {
    console.log(place);

    setStreetViewCapId(place?.placeId);
    if (place) {
      const panoLat = place?.lat;
      const panoLng = place?.lng;
      setInitPanoPosition({
        lng: panoLng,
        lat: panoLat,
      });
      setStreetViewVisibility(!streetViewVisibility);
    }
  };

  const handlePanoramaLoad = (panorama) => {
    setPanorama(panorama);
  };

  const handlePositionChanged = () => {
    if (streetViewVisibility == true && panorama) {
      const newPosition = panorama?.getPosition();
      if (newPosition) {
        const newLat = newPosition.lat();
        const newLng = newPosition.lng();

        console.log("sss");
        setPanoPosition({
          lat: newLat,
          lng: newLng,
        });
      }
    }
  };

  const handlePovChanged = () => {
    if (streetViewVisibility == true && panorama) {
      const newPov = panorama.getPov();
      console.log(newPov);
      setPanoPov(newPov);
    }
  };

  const captureStreetView = () => {
    try {
      if (panoPosition && panoPov && streetViewVisibility) {
        const { lat, lng } = panoPosition;
        const { heading, pitch, zoom } = panoPov;
        setStreetViewCapturing(true);

        const imageUrl = `https://maps.googleapis.com/maps/api/streetview?size=1980x1080&location=${lat},${lng}
        &fov=100&heading=${heading}&pitch=${pitch}&key=${mapKey}`;

        imageUrlToBase64(imageUrl)
          .then((base64String) => {
            console.log("Base64-encoded image:", base64String);
            setStreetViewCapArr((prevCap) => [...prevCap, { place_id: streetViewCapId, image: base64String }]);
            setStreetViewCapturing(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            setStreetViewCapturing(false);
          });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  async function imageUrlToBase64(imageUrl) {
    try {
      // Fetch image data using the URL
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Convert blob data to base64 string
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to base64:", error);
      throw error;
    }
  }

  const removeCap = (cap) => {
    const updatedStreetViewCapArr = streetViewCapArr.filter((item) => item?.streetViewCapId !== cap?.streetViewCapId);
    setStreetViewCapArr(updatedStreetViewCapArr);
  };

  console.log(streetViewCapArr);
  return (
    <>
      {/* Header Start */}
      <Spinner spinnerVisible={spinnerVisible}>
        <SpinnerCapture spinnerVisible={streetViewCapturing}>
          <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
            <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
              <div className="max-w-[10rem] me-auto">
                <Link to={`${ROUTES.CAL_MANAGE_CUSTOMER_DATA}?p-id=${proposalId}`}>
                  <BackButton icon={ArrowLeft} label={"Vissza"} />
                </Link>
              </div>
            </div>
            <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
              <StepBar currentStepNo={step} />
            </div>
            <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
              <div className="max-w-[10rem] ms-auto">
                <ButtonFluid label={"Mentés"} onClick={saveTourPlan} disabled={stateUpdating} />
                {/* </Link> */}
              </div>
            </div>
          </div>
          {/* Header End */}
          <div className="px-[1rem] sm:px-[5rem]  mt-[5.4rem] ">
            <div className="flex flex-col gap-10 lg:flex-row">
              <div className={`w-full lg:w-1/2 ${mapFullScreen == true ? "hidden" : ""}`}>
                <h2 className="font-bold font-lato text-[1.5rem] leading-normal  ps-2 pe-4">
                  Ajánlat száma: {proposalKey}
                </h2>

                <TripPlanner
                  getStreetView={getStreetView}
                  updateMap={updateMap}
                  distances={distances}
                  routes={routes}
                  destinations={destinations}
                  startLocations={startLocations}
                  addDestination={addDestination}
                  removeDestination={removeDestination}
                  searchChange={searchChange}
                  totalDistance={totalDistance}
                  pushStartLocation={pushStartLocation}
                />
              </div>
              <div className={`w-full  ${mapFullScreen == true ? "lg:w-full" : "lg:w-1/2 "}`}>
                <div className="mt-[3.125rem] flex flex-row gap-3">
                  <div className="w-[95%] relative">
                    {isLoaded && (
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={10}
                        onLoad={(map) => setMap(map)}
                        onUnmount={onUnmount}
                        options={{
                          zoomControl: false,
                          streetViewControl: true,
                          mapTypeControl: true,
                          fullscreenControl: false,
                          isFractionalZoomEnabled: false,
                          streetView: {
                            options: { fullscreenControl: false },
                          },
                        }}
                      >
                        {routes && <DirectionsRenderer directions={routes}></DirectionsRenderer>}
                        {streetViewVisibility && (
                          <>
                            <StreetViewPanorama
                              id="street-view"
                              position={initpanoPosition}
                              visible={true}
                              onLoad={handlePanoramaLoad}
                              onPositionChanged={handlePositionChanged}
                              onPovChanged={handlePovChanged}
                            />
                          </>
                        )}
                      </GoogleMap>
                    )}
                  </div>
                  {streetViewVisibility && (
                    <div className="">
                      <div className=" top-5 right-5">
                        <button
                          onClick={captureStreetView}
                          className="bg-[#065567]  cursor-pointer flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-[0.675rem]"
                        >
                          <img src={CameraIcon} className="w-[1.6rem]" />
                        </button>
                        <button
                          onClick={fullScreenToggle}
                          className="bg-[#065567] mt-2 cursor-pointer flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-[0.675rem]"
                        >
                          <img src={FullScreenIcon} className="w-[1.6rem]" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {streetViewCapArr && (
                  <>
                    <div className="flex flex-row flex-wrap gap-2">
                      {streetViewCapArr.map((cap, index) => (
                        <div className="relative">
                          <button
                            onClick={() => {
                              removeCap(cap);
                            }}
                            className="absolute right-0 top-0 bg-[#065567] mt-2 cursor-pointer flex items-center justify-center h-[2rem] w-[2rem] rounded-[0.675rem]"
                          >
                            <img src={BinIcon} className="w-[1.2rem]" />
                          </button>
                          <img
                            src={`data:image/png;base64, ${cap?.image}`}
                            className="inline-block w-32 mt-2 rounded"
                          />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </SpinnerCapture>
      </Spinner>
    </>
  );
};

export default Turatervezes;
